angular.module('bmsApp.sm.job')
	.factory('SMScheduleSvc', [
		'$modal',
		'$q',
		'$rootScope',
		'$window',
		'CRUDSvc',
		function ($modal,
				  $q,
				  $rootScope,
				  $window,
				  CRUDSvc) {

			var self = {
				visit: {
					read: function(params) {
						return CRUDSvc.get('api/sm/visit/read', params);
					},
				},
				calendarEvents: function (params) {
					return CRUDSvc.get('api/sm/visit/calendarEvents', params);
				},
				forDate: function (date, params) {
					return CRUDSvc.get('api/sm/visits/forDate/' + date, params);
				},
				save: function (job) {
					return CRUDSvc.post('api/sm/job/save', job);
				},
				move: function (params) {
					return CRUDSvc.post('api/sm/visit/move', params);
				},
				mergeVisits: function (params) {
					return CRUDSvc.post('api/sm/visits/merge', params);
				},
				showEditVisitModal: function (visitId) {
					var modalInstance = $modal.open({
						animation: true,
						templateUrl: 'ng/sm/schedule/templates/EditVisitModal.html',
						controller: 'SMEditVisitModalCtrl',
						size: 'md',
						scope: $rootScope,
						backdrop: 'static', // disable click-outside closing modal
						resolve: {
							visitId: function () {
								return angular.copy(visitId)
							}
						}
					});

					return modalInstance.result;
				},
				showAddVisitModal: function () {
					var modalInstance = $modal.open({
						animation: true,
						templateUrl: 'ng/sm/schedule/templates/AddVisitModal.html',
						controller: 'SMAddVisitModalCtrl',
						size: 'md',
						scope: $rootScope,
						backdrop: 'static' // disable click-outside closing modal
					});

					return modalInstance.result;
				},
				showMergeVisitModal: function (visitId) {
					var modalInstance = $modal.open({
						animation: true,
						templateUrl: 'ng/sm/schedule/templates/MergeVisitsModal.html',
						controller: 'SMMergeVisitsModalCtrl',
						size: 'md',
						scope: $rootScope,
						backdrop: 'static', // disable click-outside closing modal
						resolve: {
							visitId: function () {
								return angular.copy(visitId)
							}
						}
					});

					return modalInstance.result;
				},
				showAvailabilityModal: function (job, jobDurationMins, jobLicense, jobPostcode) {
					var modalInstance = $modal.open({
						animation: true,
						templateUrl: 'ng/sm/schedule/templates/AvailabilityModal.html',
						controller: 'SMAvailabilityModalCtrl',
						size: 'xlg',
						scope: $rootScope,
						backdrop: 'static', // disable click-outside closing modal
						resolve: {
							job: function () {
								return angular.copy(job);
							},
							jobDurationMins: function () {
								return angular.copy(jobDurationMins);
							},
							jobLicense: function () {
								return angular.copy(jobLicense);
							},
							jobPostcode: function () {
								return angular.copy(jobPostcode);
							}
						}
					});

					return modalInstance.result;
				},
				employeeScheduleOverview: function (params) {
					return CRUDSvc.get('api/sm/schedule/employee/overview', params);
				},
				employeeScheduleTimeSlots: function (params) {
					return CRUDSvc.get('api/sm/schedule/employee/time-slots', params);
				},
				printWorksheets: function (params) {
					var paramString = $.param(params);
					$window.open('sm/scheduling/worksheets?' + paramString, '_blank');
				}
			};
			return self;

		}
	]);